/**
 * Null-Check which can be used as a type predicate.
 */
export function notNull<T>(value: T | null): value is T {
    return value !== null;
}
